<template>
  <div
    class="item-search-result"
    v-if="ss.state.result"
    :id="ss.state.storeId"
  >
    <Transition name="fade">
      <div
        class="item-search-result-loader"
        v-show="resultMode === 'keyword' && ss.state.searching"
      ></div>
    </Transition>
    <UiItemSearchResultKeyword
      class="results"
      v-if="resultMode === 'keyword'"
      :test="test"
      :editstate="editstate"
      :ss="ss"
      @show="showModal($event)"
      :nonote="nonote"
    />
    <UiItemSearchResultMap
      class="results"
      v-if="resultMode === 'map'"
      :test="test"
      :ss="ss"
      @show="showModal($event)"
    />
    <UiItemSearchResultImage
      class="results"
      v-else-if="resultMode === 'image'"
      :test="test"
      :ss="ss"
      @show="showModal($event)"
    />
  </div>
  <CurationModal ref="curationModal" />
</template>

<script lang="ts" setup>
import type { CurationModal } from '#components'

const { isWebParts } = useWebParts()
const dataStore = useDataStore()
const { getImageSelectionFromItem } = useImageSelection()
const { itemAndImageSelection2ModalInfo } = useCurationModal()

interface Props {
  test?: boolean
  editstate?: CsEditState
  nonote?: boolean
  ss: SearchStore<Item>
}
const props = withDefaults(defineProps<Props>(), {
  test: false,
  nonote: false,
  editstate: null,
})
props.ss.config.configFreeze = false

const resultMode = computed(() => {
  if (
    (props.ss.state.image && props.ss.state.image.length > 0) ||
    props.ss.state.text2image
  ) {
    return 'image'
  } else if (props.ss.state.geoDistance && !isEmpty(props.ss.state.geoDistance)
  ) {
    return 'map'
  } else {
    return 'keyword'
  }
})

const curationModal = ref<InstanceType<typeof CurationModal>>()
const showModal = async (item: Item) => {
  if (!isWebParts.value) {
    return
  }
  try {
    const db = dataStore.database(item.common.database)
    const image: ImageSelection = getImageSelectionFromItem(item, db)
    const info: CurModalInfo = itemAndImageSelection2ModalInfo(item, image)
    await curationModal.value.openAwait({
      info: info
    },
    {
      animation: 'slideY',
      history: info.data ? info.data.id : '0'
    })
  } catch (cancel) {}
}



</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;
</style>
